import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookDocumentService = ( createDecorator('notebookDocumentService'));
export { INotebookDocumentService };
